import React from "react";
import { HeightAndStyle } from "./heightAndStyle";

export function HeightAndStyleDesktop() {
    return (
        <div className="artifact_group">
            <HeightAndStyle />
        </div>
    );
}
